import React, {memo} from 'react';
import Dialog from 'components/Dialog';
import {useTranslation} from 'react-i18next';
import {useChangePassword} from './redux/hooks/useChangePassword';
import {ChangePasswordForm} from './ChangePasswordForm';
import {useGetApi} from 'common/hooks/useGetApi';
import api from 'api';
import {IPasswordData} from 'types/PasswordData';
import AsyncContainer from 'components/AsyncContainer';
import {useSelector} from 'react-redux';
import {loginSelectors} from './redux';

interface Props {
   onClose: () => void;
   data?: {
      username?: string;
      title?: string;
      fromStartup?: boolean;
   };
}
const ChangePasswordDialog = memo(({onClose, data}: Props) => {
   const {t} = useTranslation();
   const {username, title = t('Change Password'), fromStartup} = data || {};

   const user = useSelector(loginSelectors.userName);
   const lastPasswordUpdate = useSelector(loginSelectors.lastPasswordUpdate);

   const [change] = useChangePassword(username || user, onClose);
   const {state: passwordData, request, loading, error: dataError} = useGetApi<IPasswordData>(
      api.passwordData
   );

   React.useEffect(() => request(), [request]);
   return (
      <Dialog maxWidth="md" header={title}>
         <AsyncContainer loading={loading && !dataError}>
            {passwordData ? (
               <ChangePasswordForm
                  onSubmit={change}
                  onClose={onClose}
                  passwordData={passwordData}
                  fromStartup={fromStartup}
                  lastPasswordUpdate={lastPasswordUpdate}
               />
            ) : null}
         </AsyncContainer>
         {/* <ChangePasswordForm username={username} onClose={onClose} /> */}
      </Dialog>
   );
});

export default ChangePasswordDialog;

/*
const useStyles = makeStyles((theme) => ({
   form: {
      width: 400,
      margin: theme.spacing(0, 'auto'),
   },
   error: {
      textAlign: 'center',
   },
}));
const _ChangePasswordForm = ({onClose, username: data}: Props) => {
   const classes = useStyles();
   const [change, error] = useChangePassword(data, onClose);
   const {t} = useTranslation();
   return (
      <Formik
         initialValues={ChangePasswordSchema.cast({})}
         validationSchema={ChangePasswordSchema}
         onSubmit={change}
      >
         {(formikProps) => (
            <Form className={classes.form}>
               <Panel>
                  <FormikTextField
                     type="password"
                     name="currentPassword"
                     label={t('Current Password')}
                     InputProps={{
                        autoFocus: true,
                     }}
                  />
                  <FormikTextField type="password" name="newPassword" label={t('New Password')} />
                  <FormikTextField
                     type="password"
                     name="newPassword2"
                     label={t('Repeat New Password')}
                  />
                  {error && (
                     <FormHelperText className={classes.error} error>
                        {error}
                     </FormHelperText>
                  )}
                  <Grid container justify="center">
                     <Grid item>
                        <FormFooterButtons formikProps={formikProps} />
                     </Grid>
                  </Grid>
               </Panel>
            </Form>
         )}
      </Formik>
   );
};
*/
